import styled from 'styled-components';
import { Tooltip, Typography } from '@mui/material';
import { ReactComponent as LockIcon } from '../../assets/16x16/lock-simple.svg';
import { Flex } from '../Flex';
import { fontSize, space } from '../../style/utils';

const LINE_HEIGHT = '21px';

const Wrapper = styled(Flex)`
  align-items: center;
  gap: ${space('sm')};
`;

const StyledLockIcon = styled(LockIcon)`
  flex-shrink: 0;
  color: ${({ theme }) => theme.palette.content.tertiary};
  width: 14px;
  height: 14px;
`;

const Label = styled(Typography)`
  font-size: ${fontSize('base')};
  line-height: ${LINE_HEIGHT};
  color: ${({ theme }) => theme.palette.content.tertiary};
`;

type RestrictedIndicatorProps = {
  label?: string;
  tooltip?: string;
};

const RestrictedIndicator = ({
  label = 'Restricted',
  tooltip = "You don't have access to this resource",
}: RestrictedIndicatorProps) => (
  <Tooltip title={tooltip} placement="top">
    <Wrapper>
      <StyledLockIcon />
      <Label>{label}</Label>
    </Wrapper>
  </Tooltip>
);

export default RestrictedIndicator;
